import { ExternalLink, Tooltip, LegacyDataTableHeaderColumn, LegacyDataTableRow, LegacyDataTableRowColumn } from "@octopusdeploy/design-system-components";
import type { ChangeFailureRateTrends, FailureRateDeployment } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import InternalLink from "~/components/Navigation/InternalLink";
import DateFormatter from "~/utils/DateFormatter";
import { CommonSparklineTrends } from "./CommonSparklineTrends";
import { TrendTable } from "./TrendTable/TrendTable";
interface FailureRateTrendTables {
    spaceId: string;
    trends: ChangeFailureRateTrends;
}
export function FailureRateTrendTables({ trends, spaceId }: FailureRateTrendTables) {
    return (<>
            <CommonSparklineTrends trends={trends} valueFormatter={(val) => (val ? `${val > 0 ? val.toFixed(1) : 0}%` : "0%")} metricDescription={<>
                        average <ExternalLink href="InsightsDeploymentFailureRate">deployment failure rate</ExternalLink>
                    </>}/>
            <RecentFailures data={trends.RecentFailures} spaceId={spaceId}/>
        </>);
}
interface RecentFailuresProps {
    spaceId: string;
    data: FailureRateDeployment[];
}
function RecentFailures({ data, spaceId }: RecentFailuresProps) {
    const hasTenants = data.some((d) => d.TenantName !== null);
    return (<TrendTable title="Recent failures" isEmpty={data.length === 0} note={<span>
                    The most recent <ExternalLink href="InsightsDeploymentFailureRate">failed deployment</ExternalLink> for each project, environment and tenant combination. The first 10 in descending order by completed time are shown.
                </span>} headerContent={<LegacyDataTableRow>
                    <LegacyDataTableHeaderColumn>Project</LegacyDataTableHeaderColumn>
                    <LegacyDataTableHeaderColumn>Environment</LegacyDataTableHeaderColumn>
                    {hasTenants && <LegacyDataTableHeaderColumn>Tenant</LegacyDataTableHeaderColumn>}
                    <LegacyDataTableHeaderColumn>Release</LegacyDataTableHeaderColumn>
                    <LegacyDataTableHeaderColumn>State</LegacyDataTableHeaderColumn>
                    <LegacyDataTableHeaderColumn>Guided failure</LegacyDataTableHeaderColumn>
                    <LegacyDataTableHeaderColumn>Completed</LegacyDataTableHeaderColumn>
                </LegacyDataTableRow>} bodyContent={<>
                    {data.map((r) => (<LegacyDataTableRow key={r.Id}>
                            <LegacyDataTableRowColumn>
                                <InternalLink to={links.projectRootRedirect.generateUrl({ spaceId, projectSlug: r.ProjectId })}>{r.ProjectName}</InternalLink>
                            </LegacyDataTableRowColumn>
                            <LegacyDataTableRowColumn>{r.EnvironmentName}</LegacyDataTableRowColumn>
                            {hasTenants && <LegacyDataTableRowColumn>{r.TenantName ?? "Untenanted"}</LegacyDataTableRowColumn>}
                            <LegacyDataTableRowColumn>
                                <InternalLink to={links.releasePage.generateUrl({ spaceId, projectSlug: r.ProjectId, releaseVersion: r.ReleaseVersion })}>{r.ReleaseVersion}</InternalLink>
                            </LegacyDataTableRowColumn>
                            <LegacyDataTableRowColumn>{r.State}</LegacyDataTableRowColumn>
                            <LegacyDataTableRowColumn>{r.HadGuidedFailure ? "True" : "False"}</LegacyDataTableRowColumn>
                            <LegacyDataTableRowColumn>
                                <Tooltip content={DateFormatter.dateToShortFormat(r.CompletedTime) || undefined}>
                                    <InternalLink to={links.deploymentPage.generateUrl({ spaceId, projectSlug: r.ProjectId, releaseVersion: r.ReleaseVersion, deploymentId: r.Id })}>{DateFormatter.momentAgo(r.CompletedTime)}</InternalLink>
                                </Tooltip>
                            </LegacyDataTableRowColumn>
                        </LegacyDataTableRow>))}
                </>}/>);
}
